import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Admitting the Fear, Without Shame",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t push myself to start. I admit: there is fear in me."
    ],
      [
      "Daily intention: Today I don’t push myself to start. I admit: there is fear in me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This fear is trying to protect me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This fear is trying to protect me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What exactly scares me about the idea of a date or new connection?\n[Write here]",
      "What thought repeats when I imagine beginning?\n[Write here]",
      "Where do I feel this fear in my body?\n[Write here]"
    ],
      [
      "What exactly scares me about the idea of a date or new connection?\n[Write here]",
      "What thought repeats when I imagine beginning?\n[Write here]",
      "Where do I feel this fear in my body?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear is not failure. It is a signal."
    ],
      [
      "Closing",
      "Fear is not failure. It is a signal."
    ]
    ),
    action: localizedGenderNode(
      "When thoughts about dating arise — one breath + “Right now I’m just listening.”",
      "When thoughts about dating arise — one breath + “Right now I’m just listening.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What I’m Afraid They’ll See in Me",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the fear of exposure."
    ],
      [
      "Daily intention: Today I touch the fear of exposure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid they will discover about me on a date?\n[Write here]",
      "Which part of me feels “not enough”?\n[Write here]",
      "Who taught me that this should be hidden?\n[Write here]"
    ],
      [
      "What am I afraid they will discover about me on a date?\n[Write here]",
      "Which part of me feels “not enough”?\n[Write here]",
      "Who taught me that this should be hidden?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The fear of exposure was born to protect."
    ],
      [
      "Closing",
      "The fear of exposure was born to protect."
    ]
    ),
    action: localizedGenderNode(
      "I write one trait I usually hide — without judging it.",
      "I write one trait I usually hide — without judging it."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Pressure to Be “Something”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I examine the pressure to perform."
    ],
      [
      "Daily intention: Today I examine the pressure to perform."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What role do I feel I must play on a date?\n[Write here]",
      "What would happen if I didn’t play it?\n[Write here]",
      "How does my body react to the idea of “impressing”?\n[Write here]"
    ],
      [
      "What role do I feel I must play on a date?\n[Write here]",
      "What would happen if I didn’t play it?\n[Write here]",
      "How does my body react to the idea of “impressing”?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Connection doesn’t start with performance. It starts with presence."
    ],
      [
      "Closing",
      "Connection doesn’t start with performance. It starts with presence."
    ]
    ),
    action: localizedGenderNode(
      "Once today — I notice when I’m trying too hard to be something.",
      "Once today — I notice when I’m trying too hard to be something."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Memories from Past Dates",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate past from present."
    ],
      [
      "Daily intention: Today I separate past from present."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which past experience still sits in my body?\n[Write here]",
      "What am I afraid will happen again?\n[Write here]",
      "What is different about me today compared to then?\n[Write here]"
    ],
      [
      "Which past experience still sits in my body?\n[Write here]",
      "What am I afraid will happen again?\n[Write here]",
      "What is different about me today compared to then?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The past explains — it does not control."
    ],
      [
      "Closing",
      "The past explains — it does not control."
    ]
    ),
    action: localizedGenderNode(
      "I tell myself: “This is a memory, not a prophecy.”",
      "I tell myself: “This is a memory, not a prophecy.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Fear of Rejection",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the fear of hearing “no.”"
    ],
      [
      "Daily intention: Today I touch the fear of hearing “no.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does rejection mean about me in my mind?\n[Write here]",
      "Where did I learn that rejection means something is wrong with me?\n[Write here]",
      "What is a gentler truth?\n[Write here]"
    ],
      [
      "What does rejection mean about me in my mind?\n[Write here]",
      "Where did I learn that rejection means something is wrong with me?\n[Write here]",
      "What is a gentler truth?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Rejection does not define worth."
    ],
      [
      "Closing",
      "Rejection does not define worth."
    ]
    ),
    action: localizedGenderNode(
      "When fear arises — hand on chest + one breath.",
      "When fear arises — hand on chest + one breath."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Body and Dating",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I listen to my body, not fight it."
    ],
      [
      "Daily intention: Today I listen to my body, not fight it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath."
    ],
      [
      "I pause with myself.",
      "One slow breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does my body do when I imagine a date?\n[Write here]",
      "Which sensation is strongest?\n[Write here]",
      "What does my body need from me right now?\n[Write here]"
    ],
      [
      "What does my body do when I imagine a date?\n[Write here]",
      "Which sensation is strongest?\n[Write here]",
      "What does my body need from me right now?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The body speaks the language of protection."
    ],
      [
      "Closing",
      "The body speaks the language of protection."
    ]
    ),
    action: localizedGenderNode(
      "Three deep breaths when tension arises.",
      "Three deep breaths when tension arises."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Why I Want a Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I return to intention."
    ],
      [
      "Daily intention: Today I return to intention."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Why do I want a relationship? (not why I “should”)\n[Write here]",
      "What feeling am I seeking?\n[Write here]",
      "What gentle intention do I set for myself?\n[Write here]"
    ],
      [
      "Why do I want a relationship? (not why I “should”)\n[Write here]",
      "What feeling am I seeking?\n[Write here]",
      "What gentle intention do I set for myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Intention softens fear."
    ],
      [
      "Closing",
      "Intention softens fear."
    ]
    ),
    action: localizedGenderNode(
      "I write one intention and keep it with me.",
      "I write one intention and keep it with me."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Slowing the Pace",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I release the pressure to rush."
    ],
      [
      "Daily intention: Today I release the pressure to rush."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who said I need to hurry?\n[Write here]",
      "What happens in me when I imagine a slow pace?\n[Write here]",
      "What relief exists in that?\n[Write here]"
    ],
      [
      "Who said I need to hurry?\n[Write here]",
      "What happens in me when I imagine a slow pace?\n[Write here]",
      "What relief exists in that?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A slow pace is safe."
    ],
      [
      "Closing",
      "A slow pace is safe."
    ]
    ),
    action: localizedGenderNode(
      "I remind myself: “Slow is allowed.”",
      "I remind myself: “Slow is allowed.”"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Boundaries on a Date",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I remember I’m allowed boundaries."
    ],
      [
      "Daily intention: Today I remember I’m allowed boundaries."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which boundary is important to me on a date?\n[Write here]",
      "What fear arises if I set it?\n[Write here]",
      "How does a boundary protect me?\n[Write here]"
    ],
      [
      "Which boundary is important to me on a date?\n[Write here]",
      "What fear arises if I set it?\n[Write here]",
      "How does a boundary protect me?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Boundaries create safety."
    ],
      [
      "Closing",
      "Boundaries create safety."
    ]
    ),
    action: localizedGenderNode(
      "I phrase one boundary for myself.",
      "I phrase one boundary for myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Not Every Connection Must Succeed",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I release the idea of “destiny.”"
    ],
      [
      "Daily intention: Today I release the idea of “destiny.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What pressure do I place on every new meeting?\n[Write here]",
      "What if this were just a meeting — nothing more?\n[Write here]",
      "How does that feel in my body?\n[Write here]"
    ],
      [
      "What pressure do I place on every new meeting?\n[Write here]",
      "What if this were just a meeting — nothing more?\n[Write here]",
      "How does that feel in my body?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A meeting is not a life exam."
    ],
      [
      "Closing",
      "A meeting is not a life exam."
    ]
    ),
    action: localizedGenderNode(
      "I say: “It’s just a meeting.”",
      "I say: “It’s just a meeting.”"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Being Me, Even with Fear",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t wait to be fearless."
    ],
      [
      "Daily intention: Today I don’t wait to be fearless."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who am I when I’m simply myself?\n[Write here]",
      "What happens if fear is present and I’m still me?\n[Write here]",
      "What relief exists in that?\n[Write here]"
    ],
      [
      "Who am I when I’m simply myself?\n[Write here]",
      "What happens if fear is present and I’m still me?\n[Write here]",
      "What relief exists in that?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Courage is being — not disappearing."
    ],
      [
      "Closing",
      "Courage is being — not disappearing."
    ]
    ),
    action: localizedGenderNode(
      "I allow myself to be natural.",
      "I allow myself to be natural."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Gradual Trust",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I remember trust is built slowly."
    ],
      [
      "Daily intention: Today I remember trust is built slowly."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What scares me about trusting?\n[Write here]",
      "What’s the difference between full trust and small trust?\n[Write here]",
      "What small trust is possible for me?\n[Write here]"
    ],
      [
      "What scares me about trusting?\n[Write here]",
      "What’s the difference between full trust and small trust?\n[Write here]",
      "What small trust is possible for me?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Trust doesn’t jump — it walks."
    ],
      [
      "Closing",
      "Trust doesn’t jump — it walks."
    ]
    ),
    action: localizedGenderNode(
      "I offer one small trust.",
      "I offer one small trust."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Choosing Gentle Movement",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I choose movement, not a leap."
    ],
      [
      "Daily intention: Today I choose movement, not a leap."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step feels possible?\n[Write here]",
      "What fear surrounds that step?\n[Write here]",
      "What strengthens me about it?\n[Write here]"
    ],
      [
      "What small step feels possible?\n[Write here]",
      "What fear surrounds that step?\n[Write here]",
      "What strengthens me about it?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Progress doesn’t have to hurt."
    ],
      [
      "Closing",
      "Progress doesn’t have to hurt."
    ]
    ),
    action: localizedGenderNode(
      "I take one small step only.",
      "I take one small step only."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure of the Journey",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I summarize without pressure."
    ],
      [
      "Daily intention: Today I summarize without pressure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about my fear?\n[Write here]",
      "What strengthened in me?\n[Write here]",
      "A return sentence for stressful days:\n[Write here]"
    ],
      [
      "What did I learn about my fear?\n[Write here]",
      "What strengthened in me?\n[Write here]",
      "A return sentence for stressful days:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I don’t have to rush to be worthy of love.",
      "I can move at my own pace.",
      "With fear — and with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I don’t have to rush to be worthy of love.",
      "I can move at my own pace.",
      "With fear — and with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that honors my pace.",
      "One action that honors my pace."
    ),
  },
].map(buildNormalizedDay);

export const fearStartingRelationshipDatingAnxietyBlueprintEn = buildNormalizedPilotBlueprint({
  id: "fear_starting_relationship_dating_anxiety_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "fear_starting_relationship_dating_anxiety",
  category: "general",
  journeyName: {
    he: "פחד להתחיל קשר (דייטים מלחיצים)",
    en: "Fear of Starting a Relationship (Dating Anxiety)",
    es: "Miedo a Iniciar una Relación (Citas que Generan Ansiedad)",
  },
  days,
});

export default fearStartingRelationshipDatingAnxietyBlueprintEn;
